/**
 * Toggles a button's in-flight state: disabled + the .is-busy spinner class
 * (styles-v2.css §"Busy buttons") + aria-busy for screen readers. Call with
 * true right before an await on a server call, false in the finally.
 *
 * Lives outside src/admin/ so public pages (login, contact, sign, approve,
 * request wizard) can use it without pulling the admin shell into their
 * bundles; src/admin/shell.ts re-exports it for the admin pages.
 */
export function setButtonBusy(btn: HTMLButtonElement | null, busy: boolean): void {
  if (!btn) return;
  btn.disabled = busy;
  btn.classList.toggle('is-busy', busy);
  btn.setAttribute('aria-busy', String(busy));
}
